/** api date format in some endpoints */
export const MOMENT_QUERY_FORMAT = 'YYYYMMDD'
export const MOMENT_QUERY_HOUR_FORMAT = 'HH'
